const IntroduceSectionTitle = ({ children }) => (
    <div className="introduce-section-title">
        <h4>{children}</h4>
        <span />
    </div>
);

export default IntroduceSectionTitle;
